import { HTTPService } from './httpService';

const API = new HTTPService();

export const TermsAPI = {
  getStatus: async (userId) => {
    const response = await API.get('/api/terms/status', { userId });
    return response.data;
  },

  accept: async (userId, versionId) => {
    const response = await API.post('/api/terms/accept', { userId, versionId });
    return response.data;
  }
};
